import type { ConnectedPosition } from '@angular/cdk/overlay';
import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import {
  booleanAttribute,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  output,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Subject } from 'rxjs';

import { FnBindPipe } from '@core/common-legacy';
import type { DisqualifyReason } from '@core/disqualify-reasons-types';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

import { DisqualifyReasonsDropdownTemplateComponent } from '../disqualify-reasons-dropdown-template/disqualify-reasons-dropdown-template.component';

@Component({
  selector: 'rt-disqualify-reasons-dropdown',
  templateUrl: './disqualify-reasons-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    OverlayOriginDirective,
    WalkthroughStepOriginDirective,
    NgTemplateOutlet,
    ConnectedOverlayDirective,
    DropdownComponent,
    DisqualifyReasonsDropdownTemplateComponent,
    FnBindPipe,
  ],
})
export class DisqualifyReasonsDropdownComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  public readonly dropdownPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
    },
  ];

  public readonly collection = input<DisqualifyReason[]>([]);
  public readonly triggerTpl = input<TemplateRef<any>>(undefined!);
  public readonly hasClear = input<boolean>(false);
  public readonly hasEditOption = input<boolean>(true);
  public readonly withPush = input<boolean, unknown>(true, { transform: booleanAttribute });
  @Input() public customDropdownPositions: ConnectedPosition[];

  public select = output<{
    disqualifyReason: DisqualifyReason;
  }>();
  public edit = output<void>();
  public clear = output<void>();
  public actionsDetails = output<{
    disqualifyReason: DisqualifyReason;
  }>();

  public isOpen: boolean = false;

  @ViewChild(DisqualifyReasonsDropdownTemplateComponent, {
    read: DisqualifyReasonsDropdownTemplateComponent,
  })
  private dropdownTemplate: DisqualifyReasonsDropdownTemplateComponent;

  private ngOnDestroy$ = new Subject<void>();

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public toggle = (open?: boolean) => {
    if (this.isOpen) {
      this.dropdownTemplate.resetSearch();
    }

    this.isOpen = open ?? !this.isOpen;
    this.cdRef.detectChanges();
  };

  public beforeWalkthroughTooltipRender() {
    this.toggle(true);
  }
}
